import React, { forwardRef } from 'react';

import { Checkbox } from 'antd';

const CheckboxGroup = forwardRef(({
    value,
    options,
    onChange,
    ...otherProps
}, ref) => {

    return (
        <Checkbox.Group
            ref={ref}
            value={value}
            onChange={onChange}
            {...otherProps}
        >
            {options.map(option => {
                return (
                    <Checkbox
                        key={option.key}
                        value={option.key}
                    >
                        {option.label}
                    </Checkbox>
                );
            })}
        </Checkbox.Group>
    );
});

export default CheckboxGroup;
